module.exports = __webpack_public_path__ + "img/banner-my.2b28cd9.jpg";